import { Core as YubinBangoCore } from 'yubinbango-core'
import moment from 'moment'
moment.locale('ja')

const ptnAllZero = new RegExp('^0+$')

// 全角数字を半角数字に変換し、半角数字のみ残す
export const restHalfNumber = (str) => {
  let retStr = str

  // 大文字数字を小文字数字へ
  retStr = retStr.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
  // 数値以外は削除
  retStr = retStr.replace(/[^0-9]/g, '')

  return retStr
}

// 全角カナ以外を削除
export const restKana = (str) => {
  let retStr = str

  retStr = retStr.replace(/[^ァ-ヶ]/g, '')

  return retStr
}

// 先頭の0を削除する
export const deleteTopZero = (str) => {
  let retStr = str

  // ALL0
  if (ptnAllZero.test(retStr)) {
    return '0'
  }

  // 先頭の0を削除
  retStr = retStr.replace(/^0+/g, '')

  return retStr
}

// 表示用の金額を取得する
export const formatPrice = (price) => {
  if (!price) return '￥0'
  let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  return '￥' + ret
}

// 拡大サイズ(_B付き画像)のファイル名を取得
export const bigImage = (imgName) => {
  let index = String(imgName).indexOf('.')
  let file = String(imgName).substring(0, index)
  let exp = String(imgName).substring(index, imgName.length)
  return file + '_B' + exp
}

// // 郵便番号から住所取得
// export const addressCompletion = async (postcd, callback) => {
//   let address = {}
//   let ret = isExistPostcd(postcd)
//   if (!ret) {
//     address['state'] = ''
//     address['city'] = ''
//     address['street'] = ''
//     callback(address)
//     console.log('address comp1')
//   }
//   console.log('address comp2')
//   ret = new YubinBangoCore(postcd, (addr) => {
//     console.log('address comp3')
//     address['state'] = addr.region
//     address['city'] = addr.locality
//     address['street'] = addr.street
//     callback(address)
//     console.log('address comp4')
//   })
// }

// 郵便番号から住所取得
export const addressCompletion = async (postcd, callback) => {
  let address = {}
  let ret = isExistPostcd(postcd)
  if (!ret) {
    address['state'] = ''
    address['city'] = ''
    address['street'] = ''
    console.log('address comp1')
    callback(address)
    return
  }
  console.log('address comp2')
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('time out')
    }, 3000)
    ret = new YubinBangoCore(postcd, (addr) => {
      address['state'] = addr.region
      address['city'] = addr.locality
      address['street'] = addr.street
      console.log('address comp3')
      callback(address)
      resolve()
    })
  })
}

export const isExistPostcd = (postcd) => {
  if (!postcd || postcd.length <= 0) return false
  let top3code = postcd.substring(0, 3)
  if (top3code === '000' ||
    top3code === '008' || top3code === '009' || top3code === '032' ||
    top3code === '117' || top3code === '118' || top3code === '119' ||
    top3code === '122' || top3code === '126' || top3code === '127' ||
    top3code === '128' || top3code === '129' || top3code === '138' ||
    top3code === '139' || top3code === '147' || top3code === '148' ||
    top3code === '149' || top3code === '159' || top3code === '172' ||
    top3code === '199' || top3code === '200' || top3code === '209' ||
    top3code === '217' || top3code === '218' || top3code === '219' ||
    top3code === '228' || top3code === '229' || top3code === '268' ||
    top3code === '269' || top3code === '280' || top3code === '281' ||
    top3code === '291' || top3code === '423' || top3code === '429' ||
    top3code === '499' || top3code === '548' || top3code === '588' ||
    top3code === '608' || top3code === '609' || top3code === '628' ||
    top3code === '686' || top3code === '687' || top3code === '688' ||
    top3code === '724' || top3code === '748' || top3code === '908' ||
    top3code === '909' || top3code === '977' || top3code === '978'
  ) {
    return false
  }
  return true
}

// 表示用の日付
export const getViewDate = (date) => {
  return moment(date).format('YYYY年MM月DD日(ddd)')
}

// あり、なし
export const getOnOff = (val) => {
  if (val) {
    return 'あり'
  } else {
    return 'なし'
  }
}

// はい、いいえ
export const getYesNo = (val) => {
  if (val) {
    return 'はい'
  } else {
    return 'いいえ'
  }
}



// WEBPACK FOOTER //
// ./src/main/js/utils/FormUtil.js